var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,60c-15.4395,0-28-12.5605-28-28S16.5605,4,32,4s28,12.5605,28,28-12.5605,28-28,28Zm0-54c-14.3364,0-26,11.6636-26,26s11.6636,26,26,26,26-11.6636,26-26S46.3369,6,32,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,31h-4v2h4c.5522,0,1-.4478,1-1s-.4478-1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,13c0,.5522,.4478,1,1,1s1-.4478,1-1v-4h-2v4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,31h-4c-.5527,0-1,.4478-1,1s.4473,1,1,1h4v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4434,15.0293c-.0359-.0359-.0819-.0514-.1215-.0807-.4503,.4528-.9099,.9193-1.3654,1.385,.027,.0355,.0405,.0773,.0729,.1097l1.4146,1.4146c.1953,.1953,.4512,.293,.707,.293s.5117-.0977,.707-.293c.3906-.3906,.3906-1.0234,0-1.4141l-1.4146-1.4146Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6782,14.9486c-.0396,.0293-.0856,.0448-.1215,.0807l-1.4141,1.4146c-.3906,.3906-.3906,1.0239,0,1.4141,.1953,.1953,.4512,.293,.707,.293s.5117-.0977,.707-.293l1.4141-1.4146c.0324-.0324,.0458-.0743,.0729-.1097-.4556-.4658-.9152-.9323-1.3654-1.385Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7363,49.2637c-.2559,0-.5117-.0977-.707-.293-.0259-.0259-.0498-.0527-.0723-.0801-4.4873-4.5264-6.957-10.52-6.957-16.8906,0-13.2339,10.7666-24,24-24s24,10.7661,24,24c0,6.3706-2.4697,12.3643-6.957,16.8906-.0225,.0273-.0469,.0542-.0723,.0801-.3906,.3906-1.0234,.3906-1.4141,0h0l-1.4141-1.4146c-.3906-.3906-.3906-1.0239,0-1.4141,.3906-.3906,1.0234-.3906,1.4141,0l.6875,.6875c3.7197-4.064,5.7559-9.2915,5.7559-14.8296,0-12.1309-9.8691-22-22-22S10,19.8691,10,32c0,5.5381,2.0366,10.7656,5.7559,14.8301l.688-.688c.3906-.3906,1.0234-.3906,1.4141,0s.3906,1.0234,0,1.4141l-1.4082,1.4082-.0049,.0049-.0015,.0015c-.1953,.1953-.4512,.293-.707,.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7275,19.272c-.3906-.3906-1.0234-.3906-1.4141,0l-10.6064,10.6069c-.0627,.0627-.0984,.1392-.141,.2123,.6463,.1918,1.1509,.6964,1.3427,1.3427,.0731-.0425,.1497-.0783,.2123-.141l10.6064-10.6069c.3906-.3906,.3906-1.0234,0-1.4141Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,35c-1.6543,0-3-1.3457-3-3s1.3457-3,3-3,3,1.3457,3,3-1.3457,3-3,3Zm0-4c-.5513,0-1,.4487-1,1s.4487,1,1,1,1-.4487,1-1-.4487-1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,52H24c-.5522,0-1-.4478-1-1v-4c0-.5522,.4478-1,1-1h16c.5527,0,1,.4478,1,1v4c0,.5522-.4473,1-1,1Zm-15-2h14v-2h-14v2Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "a`"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "aa"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "ab"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "ad"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "ae"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "af"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/Fuel.aa8bdf280a676cdd4e26a523a6e693a6.svg";
export { ForwardRef as ReactComponent };